import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
  'GET_SERVICE_VIDEOS',
  'CREATE_SERVICE_VIDEOS',
  'GET_ALL_SERVICE_VIDEOS',
  'DELETE_SERVICE_VIDEOS',
);
